<div class="dialog-header">
  <mat-icon color="warn">error_outline</mat-icon>
  <span>{{ 'Ein Fehler ist aufgetreten' }}</span>
</div>

<mat-dialog-content class="dialog-body">
  <p class="error-msg">{{ data.title }}</p>
</mat-dialog-content>

<div mat-dialog-actions class="dialog-footer">
  <button mat-dialog-close mat-raised-button color="basic" (click)="onCancel()" *ngIf="data.buttonNo">
    {{ data.buttonNo }}
  </button>
  <button mat-raised-button color="warn" (click)="onRetry()">
    {{ data.buttonYes }}
  </button>
</div>